<template>
    <v-container fluid>
        <div class="modal-padding cp3-modal">
            <v-row>
                <v-col cols="12" sm="12">
                    <div class="show-drop-down">
                        <div class="label-data">Edit D.E.O:</div>
                        <div class="field-data">
                            <v-text-field
                                v-model="name"
                                class="fix-200"
                            ></v-text-field>
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" sm="12">
                    <div class="show-drop-down">
                        <div class="label-data">Email ID:</div>
                        <div class="field-data">
                            <v-text-field
                                v-model="email"
                                class="fix-200"
                            ></v-text-field>
                            <InputError :data="error.email" />
                        </div>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12">
                    <div class="bottom-btn">
                        <v-btn
                            :loading="approvalLoading"
                            @click="onSaveOrApprove(1)"
                            class="right-btn cust-btn"
                            color="primary"
                            >Approve</v-btn
                        >
                        <v-btn
                            :loading="saveLoading"
                            @click="onSaveOrApprove(0)"
                            class="right-btn cust-btn"
                            color="primary"
                            >Save & return</v-btn
                        >
                        <v-btn
                            @click="onClose({ status: false })"
                            class="right-btn cust-btn"
                            color="primary"
                            >Cancel</v-btn
                        >
                    </div>
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
    name: "EditTeacherDetails",
    props: ["onClose", "data", "status"],
    data() {
        return {
            name: this.data ? this.data.name : "",
            email: this.data ? this.data.email : "",
            approvalLoading: false,
            saveLoading: false,
            error: {
                name: {
                    type: null,
                    message: "Please enter name",
                },
                email: {
                    type: null,
                    message: "Please enter email address",
                },
            },
        };
    },
    methods: {
        ...mapActions({
            updateExternalUser: "userStore/updateExternalUser",
        }),
        onSaveOrApprove(requireApproval) {
            if (this.validate()) {
                let reqData = {
                    role_id: this.roleIds.ED,
                    status: 1,
                    user_id: this.data.id,
                    is_approved: requireApproval,
                    name: this.name,
                    email: this.email,
                };

                this.approvalLoading = requireApproval;
                this.saveLoading = !requireApproval;
                this.updateExternalUser(reqData)
                    .then((response) => {
                        this.approvalLoading = false;
                        this.saveLoading = false;
                        if (requireApproval === 1) {
                            this.$toasted.success(
                                `Approval status changed successfully`,
                                { icon: "check_circle" }
                            );
                        } else {
                            this.$toasted.success(
                                `DEO Details Updated successfully`,
                                { icon: "check_circle" }
                            );
                        }
                        this.onClose({ status: false, reload: true });
                    })
                    .catch((err) => {
                        this.approvalLoading = false;
                        this.saveLoading = false;
                    });
            }
        },
        validate() {
            this.email = this.removeWhiteSpacesFromEmail(this.email);
            let isValid = true;
            this.error.name.type = null;
            this.error.email.type = null;
            if (!this.name || this.name.length < 1) {
                this.error.name.type = "error";
                isValid = false;
            }
            if (!this.email) {
                this.error.email.type = "error";
                isValid = false;
            }
            if (!this.email || this.email.length < 1) {
                this.error.email.type = "error";
                this.error.email.message = "Please enter email ID.";
                isValid = false;
            } else if (!this.isValidEmail(this.email)) {
                this.error.email.type = "error";
                this.error.email.message =
                "Please enter a valid email ID.";
                isValid = false;
            }
            return isValid;
        },
    },
    mounted() {},
    watch: {
        status(val) {
            this.name = this.data ? this.data.name : null;
            this.email = this.data ? this.data.email : null;
        },
        selectedClass(val) {
            this.error.class_code.type = null;
        },
        name() {
            this.error.name.type = null;
        },
    },
};
</script>
